export default __webpack_public_path__ + "static/media/icon-pathwayreport_readiness.13d5a410.png";